import { User } from 'firebase/auth';
import { FieldValue } from 'firebase/firestore';
import { i18n } from 'i18next';

import { Partner } from './common';
import {
  CreditImportance,
  DebtAmount,
  DebtCause,
  DebtTypes,
  EmploymentStatus,
  Goal,
  HouseholdIncome,
  IncomeConsistency,
  LeadType,
  LivingStatus,
  LoanOptions,
  PaymentStatus,
} from './counselor';

export interface EngagementAttributes {
  credit_rating: string;
  credit_importance: CreditImportance;
  debt_types: DebtTypes[];
  debt_amount: DebtAmount;
  hardship_reason: DebtCause;
  employment_status: EmploymentStatus;
  mortgage_in_2_years: LoanOptions;
  auto_in_2_years: LoanOptions;
  relief_goal: Goal;
  household_income: HouseholdIncome;
  hhi_consistency: IncomeConsistency;
  homeowner_status: LivingStatus;
  payment_status: PaymentStatus;
  forceQualification?: boolean;
}

export interface EngagementAddress {
  state?: string;
  zip?: string;
}

export interface EngagementProfile {
  address: EngagementAddress;
  email: string;
  first_name: string;
  language: string;
  last_name: string;
  phone_mobile: string;
  contact_preference: string;
}

export enum DevLoanTypes {
  MORTGAGE = 'mortgage',
  AUTO = 'auto',
}

export interface EngagementData {
  attributes: EngagementAttributes;
  updated_by: string;
  created_by: string;
  date_created?: FieldValue;
  date_submitted?: FieldValue;
  date_updated: FieldValue;
  experiment_id: string;
  experiment_name: string;
  id: string;
  lead_type: LeadType;
  ga_client_id: string;
  partner_id: string;
  partner_name: string;
  partner_mode?: string;
  profile: EngagementProfile;
  remote_ip: string;
  status: string;
  campaign_call_number: string;
  PID: string;
  partnerReferenceId: string;
  applicant_trusted_form_url: string;
  percent_complete?: number;
  last_page_collected: string;
  passthroughParams?: object;
  host_url?: string;
  servicer_id?: string;
  fbclid: string;
}

export interface EngagementInfo {
  user: User;
  ip?: string;
  gaClientId?: string;
  partner: Partner;
  i18n: i18n;
  campaignCallNumber?: string;
  pid?: string;
  percentComplete?: number;
  pageTitle: string;
  hostUrl?: string;
}

export interface StatusOptions {
  PENDING: string;
  READY: string;
  COMPLETE: string;
  READY_FOR_SUBMISSION: string;
  PENDING_ONBOARDING: string;
  USER_ABANDONED: string;
}
